import * as React from 'react';

import { ActionIcon } from './ActionIcon';
import { DiscountIcon } from './DiscountIcon';
import { MaternalCapitalIcon } from './MaternalCapitalIcon';
import { MilitaryMortgageIcon } from './MilitaryMortgageIcon';
import { MortgageIcon } from './MortgageIcon';
import { EType } from '../../../../types/villagePromotions';

export function getPromoIcon(type: EType): React.ReactElement {
  switch (type) {
    case EType.Sale:
      return <DiscountIcon />;
    case EType.Mortgage:
      return <MortgageIcon />;
    case EType.Bonus:
      return <ActionIcon />;
    case EType.MilitaryMortgage:
      return <MilitaryMortgageIcon />;
    case EType.MaternalCapital:
      return <MaternalCapitalIcon />;
  }
}
